export enum EventRegistrationRequiredFieldsType {
  FirstLastNameEmailRequired = 1,
  AllFieldsRequired = 0
}
